import { Component, OnInit } from '@angular/core';
import { EntidadesService } from '@core/services/entidades.service';
import { MovimentacaoSocietariaService } from '@core/services/movimentacao-societaria.service';
import FileSaver from 'file-saver';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-movimentacao-societaria-historico-export-modal',
  templateUrl: './movimentacao-societaria-historico-export-modal.component.html',
  styleUrls: ['./movimentacao-societaria-historico-export-modal.component.scss']
})
export class MovimentacaoSocietariaHistoricoExportModalComponent implements OnInit {

  entidadesOptions: any[] = [];
  entidadeIdsSelecionadas: number[] = [];
  carregandoEntidades = false;

  constructor(
    private modalRef: NzModalRef,
    private entidadesService: EntidadesService,
    private movimentacaoSocietariaService: MovimentacaoSocietariaService,
  ) { }

  ngOnInit(): void {
    this.carregandoEntidades = true;
    this.entidadesService.entidadeMudancaCombo().subscribe({
      next: (entidades: any[]) => {
        this.entidadesOptions = entidades;
        this.carregandoEntidades = false;
      },
      error: () => {
        this.carregandoEntidades = false;
      }
    });
  }

  get podeExportar(): boolean {
    return this.entidadeIdsSelecionadas.length > 0;
  }

  exportarExcel(): void {
    if (!this.podeExportar) {
      return;
    }
    this.movimentacaoSocietariaService.gerarHistoricoExcel(this.entidadeIdsSelecionadas).subscribe((response: any) => {
      const fileName = response.headers.get('filename') || 'historico-movimentacao-societaria.xlsx';
      FileSaver.saveAs(response.body, fileName);
      this.modalRef.close();
    });
  }

  exportarPdf(): void {
    if (!this.podeExportar) {
      return;
    }
    this.movimentacaoSocietariaService.gerarHistoricoPdf(this.entidadeIdsSelecionadas).subscribe((response: any) => {
      const fileName = response.headers.get('filename') || 'historico-movimentacao-societaria.pdf';
      FileSaver.saveAs(response.body, fileName);
      this.modalRef.close();
    });
  }

  fecharModal(): void {
    this.modalRef.close();
  }
}
